export const environment = {
  production: true,
  baseApiUrl: 'https://sc-api-demo.rw3.app/',
  baseAppUrl: 'https://sc-demo.rw3.app/',
  env: 'demo'
};
